import { VPR_TASK_RESULT_INVALID, VPR_TASK_RESULT_NONE, VPR_TASK_RESULT_PART, VPR_TASK_RESULT_VALID } from '@/config'

export default class ChildVprTaskProgress {
  constructor (data) {
    if (!data || !data.task_id) throw new Error('Invalid ChildVprTaskProgress data.')

    this.taskId = data.task_id

    this.status = data.status ?? VPR_TASK_RESULT_NONE

    this.playerState = data.player_state ? JSON.parse(data.player_state) : null

    this._preloaded = false
  }

  get preloaded () { return this._preloaded }

  setPreloaded = () => { this._preloaded = true }

  get statusSmileName () {
    switch (this.status) {
      case VPR_TASK_RESULT_VALID:
        return 'smile-success'
      case VPR_TASK_RESULT_PART:
        return 'smile-normal'
      case VPR_TASK_RESULT_INVALID:
        return 'smile-failed'

      default:
      case VPR_TASK_RESULT_NONE:
        return null
    }
  }
}
